import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import { Controller } from 'react-hook-form';
import FormHelperText from '@mui/material/FormHelperText';
import Button from '@mui/material/Button';

export default function MyMultiSelectField(props) {
  const { label, name, control, width, options } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, value },
        fieldState: { error },
      }) => (
        <FormControl variant="standard" sx={{ width: { width } }}>
          <InputLabel id="demo-multiple-select-label">{label}</InputLabel>
          <Select
            labelId="demo-multiple-select-label"
            id="demo-multiple-select"
            multiple
            value={value || []}
            onChange={(event) => onChange(event.target.value)}
            renderValue={(selected) => (
              <div>
                {selected.length === 0 ? (
                  <em>Select options</em>
                ) : (
                  selected.join(', ')
                )}
              </div>
            )}
            error={!!error}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 48 * 4.5 + 8,
                  width: 250,
                },
              },
              getContentAnchorEl: null, 
            }}
          >
            {options.map((option) => (
              <MenuItem key={option} value={option}>
                <Checkbox checked={value.indexOf(option) > -1} />
                <ListItemText primary={option} />
              </MenuItem>
            ))}
          </Select>
          {error && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
}
